import { Select } from 'antd';
import styled from 'styled-components';

export const HeaderDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;

  h3 {
    margin: 0;
  }
`;

// const $greyColor =  '#808080'
const $successColor = '#3be6b1';
const $alertColor = '#ff6767';
const $warningColor = '#ffa401';

const colorMap = {
  unsubmitted: $alertColor,
  submitted: $warningColor,
  on_hold: $alertColor,
  awaiting_approval: $warningColor,
  awaiting_payment: $warningColor,
  paid: $successColor,
};

export const InvoiceStatusSelect = styled(Select)`
  ${Object.keys(colorMap).map(
    state => `
      &.${state} {
        .ant-select-selection {
          background-color: ${colorMap[state]}
          color: white;
          font-weight: bold;
        }
        .ant-select-arrow .ant-select-arrow-icon {
          color: white;
        }
      }
    `
  )}
`;
